import Button from "../../../components/Buttons/Button";
import Header from "../../../components/Header/Header";
import ResultInform from "../../../components/ResultInform/ResultInform";
import PrivacyAgree from "./../../../features/Error/unavailable/components/Modal/PrivacyAgree";
import QuickMenu from "./../../../components/QuickMenu/QuickMenu";
import useQuickNemu from "#hooks/quickMenu/useQuickMenu";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import { useEffect, useState } from "react";
import useReactGASend from "../../../hooks/useReactGASend";
import { useDispatch } from "react-redux";
import { initUnavailableCount } from "#src/modules/reducers/chat/agent/connectChatServer.js";
import { initUnavailableCount  as initSendbirdStatus } from "#src/modules/reducers/chat/agent/getSendbirdStatus.js";

const UnavailableInfoPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { menuItems } = useQuickNemu();

  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    dispatch(initUnavailableCount());
    dispatch(initSendbirdStatus());
  }, [])

  useEffect(() => {
    const handlePopState = () => {
      if (location.search.includes("agree=true")) {
        navigate("/service-unavailable");
      } else {
        navigate("/landing");
      }
    };

    window.history.pushState(null, "", location.pathname + location.search);
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location.search, navigate]);

  useEffect(() => {
    const queryParams = queryString.parse(location.search);
    if (queryParams.agree) {
      openModal();
    } else {
      closeModal();
    }
  }, [location.search]);

  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  const goBack = () => {
    navigate("/landing");
  }

  return (
    <>
      <section className="!px-0 p-hasHeader">
        <Header title="고객지원 안내" goBack={goBack} />

        <ResultInform
          label={
            <>
              채팅 상담 연결이 원활하지 않습니다. <br /> 잠시 양해
              부탁드리겠습니다.
            </>
          }
          unavailable
        />
        <PrivacyAgree isOpen={modalIsOpen} onRequestClose={closeModal} />

        <QuickMenu menuItems={menuItems} />
        <div className="px-4 mt-10">
          <Button
            type="submit"
            arrow
            onClick={() => {
              navigate("/service-unavailable?agree=true");
              trackButtonClick("문의사항 접수 클릭");
            }}
          >
            문의사항 접수
          </Button>
        </div>
      </section>
    </>
  );
};

export default UnavailableInfoPage;
